import { useSyncExternalStore } from 'react';
import { getChainId } from '../actions/getChainId';
import { watchChainId } from '../actions/watchChainId';
import { useContext } from '../context';

export function useChainId() {
  const { config } = useContext();

  return useSyncExternalStore(
    (onChange) => watchChainId(config, { onChange }),
    () => getChainId(config),
    () => getChainId(config)
  );
}
